import { useEffect, useState, useCallback } from "react"
import SlotManagementModal from "../components/SloatManagement";
import { pmndpAPI } from "../../../services/pmndp.api";
import { PMNDPTableSkeleton } from '../components/PMNDPLoader';
import '../components/pmndp-enhanced.css'; // Temporary fix

export const SlotManagement = () => {
    const labels = {
        slotList: "Slot List",
        addSlot: "Add Slot",
        machineSerialNo: "Machine Serial No",
        enterMachineSerial: "Enter machine serial number",
        slotDate: "Slot Date",
        search: "Search",
        reset: "Reset",
        sNo: "S.No.",
        machineType: "Machine Type",
        availableSlots: "Available Slots",
        action: "Action",
        occupied: "Occupied",
        available: "Available",
        noSlots: "No slots",
        editSlot: "Edit Slot"
    };

    const [addSlot, setAddSlot] = useState(false);
    const [editSlotData, setEditSlotData] = useState(null);

    const [tableData, setTableData] = useState([]); // Assuming this state is used to store the dialysis history data

    // Add search state
    const [searchSerial, setSearchSerial] = useState('');
    const [searchDate, setSearchDate] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15); // Set your page size here
    const [totalItems, setTotalItems] = useState(0);

    // Add search trigger state
    const [searchTrigger, setSearchTrigger] = useState(0);

    const getSlots = useCallback(async (pageNo = page, serial = searchSerial, date = searchDate) => {
        try {
            setIsLoading(true);
            const params = { page: pageNo, pageLength: pageSize };
            if (serial) params.sr_no = serial;
            if (date) params.slot_date = date;
            const responseSlot = await pmndpAPI.getSlotList(params);

            console.log('Slots fetched successfully:', { 
                page: pageNo, 
                serial, 
                date, 
                totalItems: responseSlot?.data?.data?.totalItems || 0,
                slotsCount: responseSlot?.data?.data?.dataGet?.length || 0
            });

            const slotData = responseSlot?.data?.data?.dataGet;
            const total = responseSlot?.data?.data?.totalItems || 0;

            if (Array.isArray(slotData)) {
                setTableData(slotData);
            } else {
                setTableData([]);
            }
            setTotalItems(total);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching slots:", error);
            setTableData([]);
            setIsLoading(false);
        }
    }, [page, pageSize, searchDate, searchSerial]);

    useEffect(() => {
        getSlots();
    }, [getSlots, searchTrigger]);

    // To open edit modal, pass the selected row's data
    const handleEdit = (item) => {
        setEditSlotData(item);
        setAddSlot(true);
    };

    // Pagination
    const totalPages = Math.ceil(totalItems / pageSize);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const getPaginationNumbers = () => {
        if (totalPages <= 5) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        if (page <= 3) {
            return [1, 2, 3, 4, 5];
        }
        if (page >= totalPages - 2) {
            return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        }
        return [page - 2, page - 1, page, page + 1, page + 2];
    };

    return (
        <div className="pmndp-enhanced-container">

            <div className="pmndp-card pmndp-fade-in">
                {/* Enhanced Header */}
                <div className="pmndp-header">
                    <div className="pmndp-header-content">
                        <div className="pmndp-header-left">
                            <div className="pmndp-icon">
                                <img src={"/images/PMNDP-logo.png"} alt="PMNDP" />
                            </div>
                            <h1 className="pmndp-title">{labels.slotList}</h1>
                        </div>
                        <button className="pmndp-add-btn" onClick={() => setAddSlot(true)}>
                            <i className="fa fa-plus"></i>
                            {labels.addSlot}
                        </button>
                    </div>
                </div>

                {/* Enhanced Filter Section */}
                <div className="pmndp-filter-section">
                    <div className="solt_machine">
                        <div className="pmndp-field" style={{ flex: 1 }}>
                            <label>{labels.machineSerialNo}</label>
                            <input
                                type="text"
                                placeholder={labels.enterMachineSerial}
                                value={searchSerial}
                                onChange={e => setSearchSerial(e.target.value)}
                            />
                        </div>
                        <div className="pmndp-field" style={{ flex: 1 }}>
                            <label>{labels.slotDate}</label>
                            <input
                                type="date"
                                value={searchDate}
                                onChange={e => setSearchDate(e.target.value)}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button
                                className="pmndp-btn pmndp-btn-primary"
                                onClick={e => { e.preventDefault(); setPage(1); setSearchTrigger(prev => prev + 1); }}
                            >
                                <i className="fa fa-search"></i>
                                {labels.search}
                            </button>
                            <button
                                className="pmndp-btn pmndp-btn-secondary"
                                onClick={e => { e.preventDefault(); setSearchSerial(''); setSearchDate(''); setPage(1); setSearchTrigger(prev => prev + 1); }}
                            >
                                <i className="fa fa-refresh"></i>
                                {labels.reset}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Enhanced Table */}
                <div className="pmndp-table-container">
                    {isLoading ? (
                        <PMNDPTableSkeleton rows={5} columns={6} />
                    ) : (
                        <div className="table-responsive">
                            <table className="pmndp-table">
                                <thead>
                                    <tr>
                                        <th>{labels.sNo}</th>
                                        <th>{labels.machineSerialNo}</th>
                                        <th>{labels.machineType}</th>
                                        <th>{labels.slotDate}</th>
                                        <th>{labels.availableSlots}</th>
                                        <th>{labels.action}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(tableData) && tableData.length > 0 ? (
                                        tableData.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{(page - 1) * pageSize + index + 1}</td>
                                                <td><strong>{item.sr_no}</strong></td>
                                                <td>
                                                    <span className="pmndp-status-badge pmndp-status-functional">
                                                        {item.machine_type}
                                                    </span>
                                                </td>
                                                <td>{new Date(item.slot_date).toLocaleDateString('en-GB')}</td>
                                                <td>
                                                    {item.slots && item.slots.length > 0 ? (
                                                        <div className="pmndp-slot-list">
                                                            {item.slots.map((slot, slotIndex) => (
                                                                <div 
                                                                    key={slot.slot_id} 
                                                                    className={`pmndp-slot-item ${
                                                                        slot.assigned_to ? 'pmndp-slot-occupied' : 'pmndp-slot-available'
                                                                    }`}
                                                                    title={slot.assigned_to ? labels.occupied : labels.available}
                                                                >
                                                                    {slot.start_time} - {slot.end_time}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <span className="pmndp-status-badge pmndp-status-non-functional">
                                                            {labels.noSlots}
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    <button 
                                                        className="pmndp-action-btn pmndp-action-btn-edit"
                                                        onClick={() => handleEdit(item)}
                                                        title={labels.editSlot}
                                                    >
                                                        <i className="fa fa-edit"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6">
                                                <div className="pmndp-empty-state">
                                                    <div className="pmndp-empty-icon">
                                                        <i className="fa fa-calendar"></i>
                                                    </div>
                                                    <div className="pmndp-empty-title">No slot data available</div>
                                                    <div className="pmndp-empty-description">No slots have been created yet. Click "Add Slot" to create your first slot.</div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    
                    {/* Enhanced Pagination */}
                    {totalPages > 1 && (
                        <div className="pmndp-pagination">
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(1)}
                                disabled={page === 1 || isLoading}
                                title="First"
                            >
                                &#171;
                            </button>
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(page - 1)}
                                disabled={page === 1 || isLoading}
                                title="Previous"
                            >
                                &#8249;
                            </button>
                            
                            {totalPages > 0 && getPaginationNumbers().map(i => (
                                <button
                                    key={i}
                                    className={`pmndp-pagination-btn ${page === i ? 'active' : ''}`}
                                    onClick={() => handlePageChange(i)}
                                    disabled={page === i || isLoading}
                                >
                                    {i}
                                </button>
                            ))}
                            
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(page + 1)}
                                disabled={page === totalPages || totalPages === 0 || isLoading}
                                title="Next"
                            >
                                &#8250;
                            </button>
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(totalPages)}
                                disabled={page === totalPages || totalPages === 0 || isLoading}
                                title="Last"
                            >
                                &#187;
                            </button>
                            
                            <span className="pmndp-pagination-info">
                                Page {page} of {totalPages}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {addSlot && (
                <SlotManagementModal
                    onClose={() => { setAddSlot(false); setEditSlotData(null); }}
                    getSlots={getSlots}
                    editData={editSlotData}
                />
            )}

            <div className="pmndp-footer">
                <p>
                    © All rights reserved by Ministry of Health & Family Welfare,
                    Government of India.
                </p>
            </div>
        </div>
    );
}
